import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SaveCalibrationError", "Failed to send data to redis.", config.defaultMessageId)